import { Redirect } from 'react-router-dom';
import SideBarContainer from 'Containers/SideBarContainer';
import Title from 'Components/Title';
import Search from 'Components/Search';
import CourseAssignmentDialog from './Components/CourseAssignmentDialog';
import { Box, Button, ListItemIcon, ListItemText, Menu, MenuItem, Paper } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { DataGrid, esES } from '@mui/x-data-grid';
import useTranslation from 'Hooks/useTranslation';
import useDefinitionSelectJobTitle from './Hooks/useDefinitionSelectJobTitle';

export default function DefinitionSelectJobTitle() {
  const { t } = useTranslation();
  const {
    shouldRedirect,
    isLoading,
    jobTitleFilters,
    selectedIds,
    anchorEl,
    pageSize,
    dialogOpen,
    columns,
    setSearch,
    openDialog,
    closeDialog,
    handleMenuClose,
    handleViewDetails,
    handleSelectionChange,
    handlePageSizeChange,
    handleDialogSuccess,
  } = useDefinitionSelectJobTitle();

  if (shouldRedirect) {
    return <Redirect to="/definicion" />;
  }

  return (
    <SideBarContainer>
      <Box display="flex" flexDirection="column" height="calc(100vh - 80px)" bgcolor="#f6f7fc" overflow="hidden">
        <Title title={t('JobTitle.Title')} subtitle={t('JobTitle.SubTitle')} />
        <Box
          display="flex"
          flexDirection="row"
          width="95%"
          margin="auto"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Box sx={{ width: '40%' }}>
            <Search placeholder={t('JobTitle.Search')} setData={setSearch} />
          </Box>
          <Button variant="contained" disabled={selectedIds.length === 0} onClick={openDialog}>
            {t('JobTitle.multiselection')}
          </Button>
        </Box>

        <Paper sx={{ width: '95%', margin: 'auto', flex: 1, minHeight: 0, mb: 2 }} elevation={0}>
          <DataGrid
            density="compact"
            rows={jobTitleFilters}
            columns={columns}
            loading={isLoading}
            checkboxSelection
            disableSelectionOnClick
            disableColumnMenu
            selectionModel={selectedIds}
            onSelectionModelChange={handleSelectionChange}
            rowsPerPageOptions={[15, 25, 50]}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            sx={{
              '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold' },
            }}
          />
        </Paper>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          <MenuItem onClick={handleViewDetails}>
            <ListItemIcon>
              <Visibility fontSize="small" />
            </ListItemIcon>
            <ListItemText>Ver detalles</ListItemText>
          </MenuItem>
        </Menu>

        <CourseAssignmentDialog
          open={dialogOpen}
          onClose={closeDialog}
          selectedJobTitleIds={selectedIds}
          onSuccess={handleDialogSuccess}
        />
      </Box>
    </SideBarContainer>
  );
}
